import { render, staticRenderFns } from "./UsersListView.vue?vue&type=template&id=24d487ba&"
import script from "./UsersListView.vue?vue&type=script&lang=ts&"
export * from "./UsersListView.vue?vue&type=script&lang=ts&"
import style0 from "./UsersListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports